import styled from "@emotion/styled";
import { Pagination } from "antd";
import { useEffect, useState } from "react";
import { Props } from "../entity/props.entity";

export const PaginationComponent = (props: Props) => {
	const [total, setTotal] = useState<number>(0);

	useEffect(() => {
		setTotal(props.value);
	}, [props]);

	return (
		<Container>
			<Pagination size='small' total={total} showTotal={(total) => `共 ${total} 条记录`} defaultPageSize={15} onChange={(page) => props.onChange && props.onChange(page)} />
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

    button {
        line-height: 12px;
    }
`;
